import { DateTime } from 'luxon';
import { toISODate, type DateTimeInput } from 'utils/dateUtils';

const parseCompactServiceDate = (value: string): string | null => {
  const format = value.length === 6 ? 'yyMMdd' : 'yyyyMMdd';
  const parsed = DateTime.fromFormat(value, format, { zone: 'utc' });

  return parsed.isValid ? parsed.toISODate() : null;
};

export const normalizeRemittanceServiceDate = (
  value?: string | null
): string | null => {
  const normalized = value?.trim();
  if (!normalized) return null;

  if (/^(\d{6}|\d{8})$/.test(normalized)) {
    return parseCompactServiceDate(normalized);
  }

  const parsed = DateTime.fromISO(normalized, { setZone: true });
  return parsed.isValid ? parsed.toISODate() : null;
};

export const resolveClaimQueryServiceDate = ({
  remittanceServiceDate,
  tariffServiceStart,
  claimServiceStart,
  timezone,
}: {
  remittanceServiceDate?: string | null;
  tariffServiceStart?: DateTimeInput;
  claimServiceStart?: DateTimeInput;
  timezone?: string | null;
}): string =>
  normalizeRemittanceServiceDate(remittanceServiceDate) ??
  toISODate(tariffServiceStart, { zone: timezone }) ??
  toISODate(claimServiceStart, { zone: timezone }) ??
  '';
